const messages = {
  en: {
    // subscription
    FirstName: 'First Name',
    LastName: 'Last Name',
    GetStarted: 'Get Started'
    
  },
  fr: {
    // subscription
    FirstName: 'Prénom',
    LastName: 'Nom',
    GetStarted: 'Démarrer'
  }
}

export default messages
